
// src/web/components/group-timeline-page.js

import React from 'react'
import PureComponent from '../../helpers/pure-component'
import ReactDOM from 'react-dom'
import connect from '../../connects/group-timeline-page'
import {
  Panel,
  Layout,
  Sidebar,
} from 'react-toolbox/lib/layout'
import {
  Button,
} from 'react-toolbox/lib/button'
import Loading from './loading.jsx'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import { InfiniteScroll, InviewSensor } from './infinite-scroller';
import twoColumnLayoutTheme from './themes/two-column-layout.css'
import oneColumnLayoutTheme from './themes/one-column-layout.css'
import Diary from './diary.jsx'
import GroupMemberIcons from './group-member-icons.jsx'
import RightSidebar from './right-sidebar.jsx'
import DiaryForm from './diary-form.jsx'
import UnreadDiariesCard from './unread-diaries-card.jsx'
import GuideMessage from './guide-message.jsx'
import InviteMembersDialog from './invite-members-dialog'

class GroupTimelinePage extends PureComponent {
  state = { already_display: false, responses: [], reviewTarget: undefined }

  loadMore = ()=> this.props.fetchDiaries(this.props)
  loader = (<div style={{ width: '100%', textAlign: 'center'}}>
              <ProgressBar type='circular' mode='indeterminate' multicolor />
            </div>)

  onScrollTop = ()=> this.refs.panel && ((ReactDOM.findDOMNode(this.refs.panel)).scrollTop = 0)

  onReplyScrollFrom = (offset)=> {
    //COMMENT_FORM_HEIGHTはコメントフォームの高さ
    const COMMENT_FORM_HEIGHT = 222
    //返信コメントへの返信の場合、コメントフォームまでスクロールする
    this.refs.panel && ((ReactDOM.findDOMNode(this.refs.panel)).scrollTop += offset + COMMENT_FORM_HEIGHT)　
  }

  setReviewTarget = (target)=> this.setState({ reviewTarget: target })

  UNSAFE_componentWillUpdate(nextProps) {
    // 日報を投稿した際、うまくタイムラインに反映されない原因不明の不具合があるための対処
    if (this.props.diaries && nextProps.diaries &&
        this.props.diaries.length != nextProps.diaries.length)
      setTimeout(()=> this.setState({ udpate: Math.random() }), 300)
  }

  componentWillUnmount() {
    if (this.state.ws) {
      this.state.ws.close();
    }
  }

  render() {
    const {
      t,
      ui,
      updateUI,
      diaries,
      user,
      group,
      isFetching,
      isFetchFailed,
      isRightSidebar,
      hasMore,
      children,
      params,
      location,
      fetchDiaries,
      showUser,
      openGroupMembersPanel,
      usersAdminUrl,
      productTour,
      firstLogin,
      likeConfig,
      blockDiaries,
      blockUsers
    } = this.props
    const parentTheme = isRightSidebar ? twoColumnLayoutTheme: oneColumnLayoutTheme

    return (
      <Layout theme={parentTheme}>
        <Panel bodyScroll theme={parentTheme} style={{ left: 0 }} ref="panel">
          {group &&
            <GroupMemberIcons group={group}
              user={user}
              users={group.members}
              showUser={showUser}
              openGroupMembersPanel={openGroupMembersPanel}
              usersAdminUrl={usersAdminUrl}
              productTour={productTour}
              firstLogin={firstLogin}/>
          }
          {group && group.is_admin &&
            <GuideMessage showMessage={firstLogin && (!productTour || productTour.openGroupMemberPanel != 'hide')}
              message={t('label:ここをクリックして招待してみよう')}
              style={{ marginTop: '10px' }} />
          }
          {group && group.can_write && diaries && <DiaryForm chatGptReview={this.state.responses} clearGptReview={this.clearGptReview} sendChatGPT={this.sendMessage} reviewTarget={this.state.reviewTarget} setReviewTarget={this.setReviewTarget} onScrollTop={this.onScrollTop} group={group} diary />}
          {group && group.can_write && diaries &&
            <GuideMessage diaryGuidance
              showMessage={firstLogin && (!productTour || productTour.submitDiary != 'hide')}
              message={t('label:ここをクリックして日報を投稿してみよう')}
              style={{ marginTop: '5px' }} />
          }
          {!diaries && isFetching && <Loading />}
          {!isFetching && group && <UnreadDiariesCard group={group} />}
          {group &&
          <InfiniteScroll pageStart={0}
              initialLoad={false}
              hasMore={hasMore && !isFetchFailed}
              loadMore={this.loadMore}
              loader={diaries && this.loader}
              useWindow={false} >
            {diaries && diaries.map((diary)=>
              <Diary chatGptReview={this.state.responses} clearGptReview={this.clearGptReview} sendChatGPT={this.sendMessage} reviewTarget={this.state.reviewTarget}
                key={diary.diary_id} diary={diary} user={user} group={group} onReplyScrollFrom={this.onReplyScrollFrom} likeConfig={likeConfig} openSidePage={isRightSidebar} blockDiaries={blockDiaries} blockUsers={blockUsers} setReviewTarget={this.setReviewTarget}/>
            ) || []}
          </InfiniteScroll>}
          {diaries && diaries.length == 0 && !hasMore && !isFetchFailed &&
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '20px' }}>
            {t('label:投稿がありません')}
            </div>
          }
          {diaries && diaries.length > 0 && !hasMore && !isFetchFailed &&
            <div style={{ fontSize: '80%', padding: '0 20px', color: '#999' }}>{t('label:一番最後の投稿です')}</div>
          }
          {isFetchFailed &&
            <div style={{ padding: '20px' }}>
              <div style={{ fontSize: '90%', marginBottom: '10px' }}>
                {t('error:読み込みに失敗しました')}
              </div>
              <Button raised
                onClick={()=> fetchDiaries(this.props, true)}
                label={t('label:再読み込み')}
                style={{ width: '100%' }}/>
            </div>
          }
        </Panel>

        {isRightSidebar &&
          <Sidebar theme={twoColumnLayoutTheme} pinned scrollY width={50}>
            <RightSidebar user={user} group={group} >
              {children}
            </RightSidebar>
          </Sidebar>
        }

        {null && user && user.account_admin && user.trial && user.is_alone && group &&
          <InviteMembersDialog group={group}
            usersAdminUrl={usersAdminUrl}
            already_display={this.state.already_display}
            onHide={()=>this.setState({ already_display: true })} />
        }
      </Layout>
    )
  }
}

export const RawGroupTimelinePage = GroupTimelinePage
export default connect(GroupTimelinePage)



// WEBPACK FOOTER //
// ./src/web/components/group-timeline-page.jsx